import React, { useEffect } from 'react';
import ModalAddTicket from './../../Components/Modal/';
import FormCreator from '../../FormBuilder';
import { ValidatorService, ValidatorSchema } from '../../Helpers';
import { Popup, Icon, Button } from 'semantic-ui-react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import { ModelCreateTicket } from './model';
import { Col, Row } from 'reactstrap';
import ImageUpload from './Components/ImageUpload';
import Axios from "axios";
import Swal from 'sweetalert2'
import { Services } from '../../Services'


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

function CreateTicket(props) {
  const [Form, setForm] = React.useState({});
  const [Model, setModel] = React.useState({ ...ModelCreateTicket() });
  const [ccTo, setccTo] = React.useState(false);
  const classes = useStyles();
  const [Catalogos, setCatalogos] = React.useState({ ...ModelCreateTicket().Catalogs });
  const [Cat, setCat] = React.useState({});
  const [disabledButton, setDisabledButton] = React.useState(true);
  const [ActiveLoader, setActiveLoader] = React.useState(true);
  const [addBtnAddEMail, setBtnAddEmail] = React.useState(true);
  const [projectId, setProjectId] = React.useState(1);
  const [rolId, setRolId] = React.useState(1);
  const [tz] = React.useState(Intl.DateTimeFormat().resolvedOptions().timeZone)


  const handleCancel = () => {
    setModel({ ...ModelCreateTicket() });
    setccTo(false)
  };

  const handleDelete = (chipToDelete) => () => {
    Model.Model.ccto.value = Model.Model.ccto.value.filter((chip) => chip.key !== chipToDelete.key);
    setModel({ Model, ...Model });
  };

  const createTicket = () => {
    setActiveLoader(false)
    Axios.post(`${Services.TICKETS.path}Ticket/createTicket`, Model.Model)
      .then((response) => {
        let idTicket = response.data.data.idTicket.rows[0].TicketId
        let TicketNumber = response.data.data.idTicket.rows[0].TicketNumber
        UpdateDoc(idTicket, TicketNumber)
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  const UpdateDoc = (id, TickNum) => {
    let docs1 = Model.Model.Documents.value
    let Languaje = { language: Model.Model.language, timezone: tz }
    if (docs1.length !== 0) {
      let docs = Model.Model.Documents.value[0].file
      let formData = new FormData();
      formData.append('image', docs)

      Axios.post(`${Services.TICKETS.path}documents/uploadDocumment/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          let data = response.data.data
          let body = { urlDoc: data.url, Name: docs1[0].filenameWithoutExtension, idTicket: id, Type: docs1[0].fileExtension, ByUser: 1, ByHelpDesk: 0 }
          Axios.post(`${Services.TICKETS.path}documents/saveDocumment`, body)
            .then(response => {
              setActiveLoader(true)
              props.GetTikets(projectId);
              Swal.fire({
                // position: 'top-end',
                icon: 'success',
                title: props.labels.alerts.new_ticket.header,
                text: `${props.labels.alerts.new_ticket.message + ' ' + TickNum}`,
                showConfirmButton: false,
                timer: 2500
              });

            }).catch(error => {
              console.log('hubo error?', error);
            })
          Axios.post(`${Services.TICKETS.path}alerts/ActiveNewTicket/${id}`, Languaje)
            .then(res => {
              console.log(res.data.message);
            }).catch(err => {
              console.log('err send mail--->', err);
            })
        }).catch(error => {
          console.log('hubo error?', error);
        })
    } else {
      setActiveLoader(true)
      props.GetTikets(projectId);
      Swal.fire({
        // position: 'top-end',
        icon: 'success',
        title: props.labels.alerts.new_ticket.header,
        text: `${props.labels.alerts.new_ticket.message + ' ' + TickNum}`,
        showConfirmButton: false,
        timer: 2500
      });
      Axios.post(`${Services.TICKETS.path}alerts/ActiveNewTicket/${id}`, Languaje)
        .then(res => {
          console.log(res.data.message);
        }).catch(err => {
          console.log('err send mail--->', err);
        })
    }
  };

  const callFile = (file) => {
    Model.Model['Documents'].value = file;
    setModel({ Model, ...Model });
  }

  const getCatalogos = React.useCallback(async () => {
    try {
      const url = `${Services.TICKETS.path}catalogos/catalogos/`;
      const { data } = await Axios.post(url, { idProject: projectId });

      const {
        dataCatTypesTickets,
        dataCatRequestModules,
        dataCatRequestTypesSubModules,
        dataCatSeverities,
        dataCatReasonsCloses
      } = data.data;

      const formatOptions = (array, keyField, valueField, textField) =>
        array.map(item => ({
          key: item[keyField],
          value: item[valueField],
          text: item[textField]
        }));

      const CatalogosFormatted = {
        TypeTicketId: formatOptions(dataCatTypesTickets, 'TypeTicketId', 'TypeTicketId', 'TypeTicket'),
        RequestModuleId: formatOptions(dataCatRequestModules, 'RequestModuleId', 'RequestModuleId', 'RequestModule'),
        RequestTypeSubModuleId: dataCatRequestTypesSubModules.map(sub => ({
          key: `${sub.RequestTypeSubModuleId}-${sub.TypeTicketId}-${sub.RequestModuleId}`,
          value: sub.RequestTypeSubModuleId,
          text: sub.Description
        })),
        CatSeverityId: formatOptions(dataCatSeverities, 'SeverityId', 'SeverityId', 'Severity'),
        ReasonsCloses: formatOptions(dataCatReasonsCloses, 'ReasonCloseId', 'ReasonCloseId', 'ReasonClose')
      };

      setCat(data.data);
      setCatalogos(CatalogosFormatted);

    } catch (error) {
      console.error('Error al obtener catálogos:', error);
    }
  }, [projectId]);

  function infoUser() {
    Model.Model['UserName'].value = `${props.PropsProject.UserName + ' ' + props.PropsProject.UserNameLast}`;
    Model.Model['Email'].value = props.PropsProject.Email;
    Model.Model['UserProjectId'].value = props.PropsProject._user;
    Model.Model['Rol'].value = props.PropsProject._Role;
    Model.Model['ProjectId'].value = props.PropsProject.ProjectId;
    Model.Model['language'].value = props.language;


    setModel({ Model, ...Model });
  };

  useEffect(() => {
    setForm(props.Form)
    getCatalogos();
    infoUser();
    setProjectId(props.PropsProject.ProjectId)
    setRolId(props.PropsProject._rolId)
  }, [getCatalogos, props]);


  function AddEmail() {
    Model.Model.ccto.value.push({ key: Math.random().toString(36).substring(7), label: `${Model.Model.NameCC.value} (${Model.Model.EmailCC.value})` });
    Model.Model.MailsBD.value.push({ name: Model.Model.NameCC.value, Mails: Model.Model.EmailCC.value });
    Model.Model.NameCC.value = undefined;
    Model.Model.EmailCC.value = undefined;
    setModel({ Model, ...Model });
    setBtnAddEmail(true)
  };



  function handleChange(evt, data) {
    const id = data.id;
    const value = data.value;
    const ModelSend = { ...Model.Model };
    ModelSend[id].value = value;

    const setModelValueAndVisibility = (typeTicketId, config = {}) => {
      Model.Model['TypeTicketId'].value = typeTicketId;
      Object.entries(config.visibility || {}).forEach(([key, visible]) => {
        if (Model.Model[key]) Model.Model[key].hidden = !visible;
      });
    };

    const getFilteredModules = (typeTicketId) => {
      return Cat.dataCatRequestModules
        .filter(e => e.TypeTicketId === typeTicketId)
        .filter(e => {
          if (typeTicketId === 2 && projectId === 2 && rolId === '3') {
            return e.RequestModuleId !== 92 && e.RequestModuleId !== 93;
          }
          return true;
        })
        .map(e => ({
          key: e.RequestModuleId,
          value: e.RequestModuleId,
          text: e.RequestModule
        }));
    };

    const getSubModules = (moduleId) => {
      return Cat.dataCatRequestTypesSubModules
        .filter(e => e.RequestModuleId === moduleId)
        .map(e => ({
          key: e.RequestTypeSubModuleId,
          value: e.RequestTypeSubModuleId,
          text: e.Description
        }));
    };

    switch (id) {
      case 'TypeTicketId':
        switch (value) {
          case 1:
            Catalogos.RequestModuleId = getFilteredModules(value);
            setModelValueAndVisibility(value, {
              visibility: {
                RequestModuleId: true,
                RequestTypeSubModuleId: true,
                CatSeverityId: true,
                Request: false,
                RequestType: false,
              }
            });
            break;
          case 2:
            Catalogos.Request = getFilteredModules(value);
            setModelValueAndVisibility(value, {
              visibility: {
                RequestModuleId: false,
                RequestTypeSubModuleId: false,
                CatSeverityId: false,
                Request: true,
                RequestType: true,
              }
            });
            break;
          case 3:
            Catalogos.RequestModuleId = getFilteredModules(value);
            setModelValueAndVisibility(value, {
              visibility: {
                RequestModuleId: true,
                RequestTypeSubModuleId: true,
                CatSeverityId: false,
                Request: false,
                RequestType: false,
              }
            });
            break;
          default:
            break;
        }
        break;

      case 'RequestModuleId':
        Catalogos.RequestTypeSubModuleId = getSubModules(value);
        break;

      case 'Request':
        Catalogos.RequestType = getSubModules(value);
        break;

      default:
        break;
    }

    const res = ValidatorService(ModelSend[id].type, value);
    const hasEmailCC = !!Model.Model.EmailCC.value;
    const hasNameCC = !!Model.Model.NameCC.value;

    if (hasEmailCC && !hasNameCC) {
      setBtnAddEmail(true);
    } else if (hasEmailCC && hasNameCC) {
      setBtnAddEmail(false);
    }

    const commonValidation = () => {
      ModelSend[id].valid = res;
      ModelSend[id].value = value;

      let requiredFields = [];
      switch (Model.Model.TypeTicketId.value) {
        case 1:
          requiredFields = ['Phone', 'RequestModuleId', 'RequestTypeSubModuleId', 'CatSeverityId', 'Subjet', 'Description'];
          break;
        case 2:
          requiredFields = ['Phone', 'Request', 'RequestType', 'Subjet', 'Description'];
          break;
        case 3:
          requiredFields = ['Phone', 'RequestModuleId', 'RequestModuleId', 'Subjet', 'Description'];
          break;
        default:
          requiredFields = [];
          break;
      }

      const isValid = ValidatorSchema(ModelSend, requiredFields);
      setDisabledButton(!isValid);
    };

    if ([1, 2, 3].includes(Model.Model.TypeTicketId.value)) {
      commonValidation();
    } else {
      ModelSend[id].valid = res;
      ModelSend[id].value = value;
      setDisabledButton(true);
    }

    setCatalogos({ Catalogos, ...Catalogos });
    setModel({ Model, ...Model });
  }


  function onclickCC() {
    setccTo(!ccTo);
  }


  return (
    <>
      <props.loader hidden={ActiveLoader} />
      <ModalAddTicket
        title={props.labels.new_ticket_form.title}
        etiquetas={props.labels.btn_new_ticket}
        onCancel={handleCancel}
        createTicket={createTicket}
        disabledButton={disabledButton}
        projectId={props.PropsProject.ProjectId}
        infoUser={infoUser}
      >
        <FormCreator dataForm={Form.ModalInfo} Model={Model.Model} onChange={handleChange} onClick={onclickCC} style={props.PropsProject.style} />
        <div className='col-12'>
          <label className='input__labelcc' onClick={onclickCC}>
            <Popup
              content={props.labels.new_ticket_form.ccto.info}
              trigger={<Icon name='info circle' size='small' color='green' />} />
            {props.labels.new_ticket_form.ccto.title}
          </label>
          <hr></hr>
          {ccTo ?
            <div className='row'>
              <Col xs={12} md={12} lg={12}>
                <Row>
                  <FormCreator dataForm={Form.ModalCCto} Model={Model.Model} onChange={handleChange} />
                  <Col xs={1} md={1} lg={1} className='d-flex align-items-center' style={{ paddingTop: 10, paddingLeft: 0 }}>
                    <Button circular color='blue' icon='add' size='mini' onClick={AddEmail}
                      disabled={addBtnAddEMail}
                    />
                  </Col>
                </Row>
              </Col>
              {Model.Model.ccto.value.length > 0 ?
                <div className='col-md-12'>
                  <Paper elevation={0} component="ul" className={classes.root}>
                    {Model.Model.ccto.value.map((data, index) => {
                      return (
                        <li key={index}>
                          <Chip
                            label={data.label}
                            onDelete={handleDelete(data)}
                            className={classes.chip}
                          />
                        </li>
                      );
                    })}
                  </Paper>
                </div>
                :
                ''
              }
            </div>
            : ''
          }
        </div>
        <FormCreator dataForm={Form.ModalSelect} Model={Model.Model} Catalog={Catalogos} onChange={handleChange} />
        <Col xs={12}>
          <ImageUpload callFile={callFile} labels={props.labels.btn_new_ticket} />
        </Col>
      </ModalAddTicket>
    </>
  );
}

export default CreateTicket;